import { createBrowserRouter } from 'react-router';
import Home from './pages';
import NPISteeringPage from './pages/mbdcp/npi_steering';
import MakeOrBuyPage from './pages/mbdcp/npi_board';
import PartSearchPage from './pages/mbdcp/part_search';
import NpiDefaultScreen from './pages/mbdcp/[appid]';
import Custom404 from './pages/404';
import FinanceRepositoryPage from './pages/mbdcp/finance_repository';
import POMonitorPage from './pages/mbdcp/po_monitor';
import PSPManagementPage from './pages/mbdcp/psp_management';
import LoginPage from './pages/login';
import UserIdentitiesPage from './pages/admin/user_identities';
import UserRolesPage from './pages/admin/user_roles';
import RoleAssignmentScreen from './pages/admin/role_assignment';
import ScreensAccessPage from './pages/admin/screens_access';
import FeatureAccessPage from './pages/admin/features_access';
import AttributesAccessScreen from './pages/admin/attributes_access';
import ScreenTableConfigurationPage from './pages/admin/grid_attribute_config';
import DropdownPage from './pages/admin/dropdowns';
import AdminDefaultPage from './pages/admin/[appid]';
import MyApp from './pages/_app';
import { sessionMiddleware } from './features/auth/sessionMiddleware';
import { loginContext } from './shared/context/loginContext';

async function sessionDataLoader({ context }) {
  const loginDetails = context.get(loginContext);

  if (!loginDetails?.userId) {
    throw new Response('Unauthorized', { status: 401 });
  }

  return { loginDetails };
}

export const router = createBrowserRouter([
  { path: 'login', element: <LoginPage /> },
  {
    element: <MyApp />,
    middleware: [sessionMiddleware],
    loader: sessionDataLoader,
    children: [
      {
        index: true,
        element: <Home />,
      },
      // MBDCP Routes
      {
        path: 'mbdcp',
        children: [
          { path: 'npi_steering', element: <NPISteeringPage /> },
          { path: 'npi_board', element: <MakeOrBuyPage /> },
          { path: 'part_search', element: <PartSearchPage /> },
          { path: 'finance_repository', element: <FinanceRepositoryPage /> },
          { path: 'po_monitor', element: <POMonitorPage /> },
          { path: 'psp_management', element: <PSPManagementPage /> },
          { path: ':screenId', element: <NpiDefaultScreen /> },
        ],
      },
      // Admin Routes
      {
        path: 'admin',
        children: [
          { path: 'user_identities', element: <UserIdentitiesPage /> },
          { path: 'user_roles', element: <UserRolesPage /> },
          { path: 'role_assignment', element: <RoleAssignmentScreen /> },
          { path: 'screens_access', element: <ScreensAccessPage /> },
          { path: 'features_access', element: <FeatureAccessPage /> },
          { path: 'attributes_access', element: <AttributesAccessScreen /> },
          { path: 'grid_attribute_config', element: <ScreenTableConfigurationPage /> },
          { path: 'dropdowns', element: <DropdownPage /> },
          { path: ':screenId', element: <AdminDefaultPage /> },
        ],
      },
      { path: '*', element: <Custom404 /> },
    ],
  },
]);
